<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Connect Your Account') }}</h4>
    </div>
    <div class="modal-body">
      <div class="row">   
        <div class="col-md-12">
          <iframe :src="url" width="100%" height="100%" frameborder="0" style="border: 0; height: 700px"></iframe>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
    </div>
  </div>
</template>

<script>
import errors from '~/lib/errors'

export default {
  mixins: [errors],
  props: ['url'],
  computed: {
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    handleMessage (event) {
      console.log(event)
      if (event.data?.event?.event_type === 'webview.login_successful') {
        this.$emit('loginSuccessful')
      }
    }
  },
  mounted () {
    window.addEventListener('message', this.handleMessage, false)
  },
  beforeUnmount() {
    window.removeEventListener('message', this.handleMessage, false)
  }
}
</script>

